import React, { useState, useEffect } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE } from "baseui/input";
import { Select, SIZE as SSIZE } from "baseui/select";
import { styled } from "baseui";
import { FlexGridItem } from "baseui/flex-grid";
const FormControlContainer = styled("legend", ({ $theme }) => ({
  padding: "2px",
  width: "max-content",
}));
const InputRowContainer = styled("div", ({ $theme }) => ({
  // display: "flex",
  // flexDirection: "row",
  // justifyContent: "start",
}));
const InputContainer = styled("div", ({ $theme }) => ({
  // padding: "5px",
  width: "220px",
}));

export default function InputItem(props) {
  const [itemValue, setItemValue] = useState(props.itemValue);
  const [initialValue, setInitialValue] = useState(props.itemValue);

  useEffect(() => {
    setItemValue(props.itemValue);
  }, [props.itemValue]);

  useEffect(() => {
    setItemValue(props.itemValue);
    setInitialValue(props.itemValue);
  }, [props.itemValue]);

  const onValueChange = (newVal) => {
    if (newVal !== initialValue) {
      props.onApplyChange(props.itemName, newVal);
    }
  };

  const handleNumericChange = (e) => {
    const newVal = Math.max(Math.min(e.target.value, props.itemMeta.maxValue || 1), props.itemMeta.minValue || 0);
    setItemValue(newVal);
  };
  
  const handleSelectChange = (params) => {
    const newVal = params.value[0]?.label;
    setItemValue(newVal);
  };
  const renderInput = () => {
    switch (props.type) {
      case "MULTIOPTION":
        return (
          <FlexGridItem>
            <FormControl
              id={`form-item-${props.itemMeta.label}`}
              disabled={props.disabled}
              label={props.itemMeta.label}
              caption={props.itemMeta.description}
            >
              <Select
                key={props.label}
                clearable={false}
                backspaceRemoves={false}
                searchable={false}
                escapeClearsValue={false}
                size={SSIZE.compact}
                value={[{ label: itemValue, id: itemValue }]}
                onChange={handleSelectChange}
                onBlur={() => onValueChange(itemValue)}
                options={(props.itemMeta.optionsList || []).map((option) => {
                  return { label: option, id: option };
                })}
                mapOptionToString={(option) => option.label}
              />
            </FormControl>
          </FlexGridItem>
        );
        case "NUMERIC":
          return (
            <FlexGridItem>
              <FormControl
                id={`form-item-${props.itemMeta.label}`}
                disabled={props.disabled}
                label={props.label}
                caption={props.itemMeta.description}
              >
                <Input
                  key={props.label}
                  type="number"
                  size={SIZE.mini}
                  value={itemValue || 0}
                  min={props.itemMeta.minValue || 0}
                  max={props.itemMeta.maxValue || 1}
                  step={props.itemMeta.step || 1}
                  onChange={(e) => setItemValue(e.target.value)}
                  onBlur={(e) => {
                    handleNumericChange(e);
                    onValueChange(itemValue)}}
                />
              </FormControl>
            </FlexGridItem>
          );
      default:
        return (
          <FlexGridItem>
            <FormControl
              id={`form-item-${props.itemMeta.label}`}
              label={props.label}
            >
              <Input
                key={props.label}
                type="text"
                size={SIZE.mini}
                value={itemValue || ""}
                onChange={(e) => setItemValue(e.target.value)}
                onBlur={() => props.onApplyChange(props.itemName, itemValue)}
              />
            </FormControl>
          </FlexGridItem>
        );
    }
  };

  return (
    <FormControlContainer key={props.inputId}>
      <InputRowContainer>
        <InputContainer>
          {renderInput()}

          {/* <Input
              type={props.type}
              size={SIZE.mini}
              value={itemValue}
              onChange={(e) => setItemValue(e.target.value)}
              onBlur={(e) =>
                props.onApplyChange(props.itemName, e.target.value)
              }
            /> */}
        </InputContainer>
        {/* <InputContainer>
          <FormControl label="Description">
            <LabelMedium>{props.description}</LabelMedium>
          </FormControl>
        </InputContainer> */}
      </InputRowContainer>
    </FormControlContainer>
  );
}
